<div class="container" [ngClass]="{ 'light-mode': !isDarkMode(), 'dark-mode': isDarkMode() }">

  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> UK MRV
  </p>

  <div class="filter-header" style="margin-top: 25px;">
    <form [formGroup]="myreportForm" class="filter-flex-container">

      <!-- Client Name -->
      <mat-form-field *ngIf="username === 'Meraki - Operations'" appearance="outline" floatLabel="always"
        class="compact-field">
        <mat-label>Client Name</mat-label>
        <mat-select formControlName="client" placeholder="Select Client">
          <mat-option value="">All Clients</mat-option>
          <mat-option *ngFor="let c of clientList" [value]="c">
            {{ c }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vessel Name -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Vessel Name</mat-label>
        <mat-select formControlName="vesselname" placeholder="Select Vessels" multiple>
          <mat-option *ngFor="let ship of vesselNameSuggestions" [value]="ship.vessel_name">
            {{ ship.vessel_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Vessel IMO -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Vessel I.M.O</mat-label>
        <input matInput formControlName="vesselIMO" placeholder="Enter IMO">
      </mat-form-field>

      <button mat-flat-button color="warn" class="fetch-btn clear-btn" (click)="clearClick()">
        Clear
      </button>

      <button mat-flat-button color="primary" class="fetch-btn" (click)="filterClick()">
        Apply Filter
      </button>

    </form>
  </div>

  <!-- TABLE -->
  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table" id="style-4" matSort>

      <thead class="sticky-header">
        <tr>
          <th>S.No</th>
          <th class="th-text-center">Ship View</th>
          <th mat-sort-header="vessel_name" class="left">Vessel Name</th>
          <th mat-sort-header="imo" class="left">IMO No</th>
          <th mat-sort-header="segment" class="left">Segment</th>

          <th mat-sort-header="uk_co2_mt">CO₂</th>
          <th mat-sort-header="uk_n2o_mt">N₂O</th>
          <th mat-sort-header="uk_ch4_mt">CH₄</th>
          <th mat-sort-header="uk_total_emissions_mt">Total Emission</th>

          <th class="th-text-center">Generate Report</th>
        </tr>
      </thead>

      <tbody>
        <!-- Skeleton Loading -->
        <ng-container *ngIf="isLoading; else dataRows">
          <tr *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
            <td colspan="10">
              <div class="skeleton-table-row skeleton"></div>
            </td>
          </tr>
        </ng-container>

        <!-- Actual Data -->
        <ng-template #dataRows>
          <tr *ngFor="let element of paginatedData; let i = index">
            <td>{{ currentPage * itemsPerPage + i + 1 }}</td>

            <!-- Ship View Icon -->
            <td class="th-text-center">
              <button class="gradient-btn" (click)="showDetails(element)"
                [ngStyle]="{ 'background-image': 'linear-gradient(98deg,#0046de,#006063)', 'border-radius': '11px', border: 'none' }">
                <mat-icon fontSet="material-icons-outlined" fontIcon="visibility" class="visiblityIcon">
                  visibility_outlined
                </mat-icon>
              </button>
            </td>

            <td class="left">{{ element.vessel_name || '-' }}</td>
            <td class="left">{{ element.imo || '-' }}</td>
            <td class="left">{{ element.segment || '-' }}</td>

            <td>{{ element.uk_co2_mt ? (element.uk_co2_mt | number:'1.0-4') : '-' }}</td>
            <td>{{ element.uk_n2o_mt ? (element.uk_n2o_mt | number:'1.0-4') : '-' }}</td>
            <td>{{ element.uk_ch4_mt ? (element.uk_ch4_mt | number:'1.0-4') : '-' }}</td>
            <td>{{ element.uk_total_emissions_mt ? (element.uk_total_emissions_mt | number:'1.0-4') : '-' }}</td>

            <!-- Generate Report -->
            <td class="text-center">
              <mat-icon matTooltip="Generate Report" (click)="openGenerateReportPopup(element)"
                style="cursor:pointer; font-size:22px">
                description
              </mat-icon>
            </td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="paginatedData.length === 0">
            <td colspan="10" class="text-center" style="padding: 20px;">
              No data available for the selected filters.
            </td>
          </tr>
        </ng-template>
      </tbody>

    </table>
  </div>

  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons>
  </mat-paginator>

</div>

<br />